var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"cr-tag",class:( _obj = {
    'cr-tag-removable': _vm.removeButton
  }, _obj[("cr-color-" + _vm.color)] = _vm.color, _obj ),on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.highlighted)?_c('i',{staticClass:"cr-tag-highlighted-icon fa fa-star"}):_vm._e(),_vm._v(" "),_c('span',[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2),_vm._v(" "),(_vm.removeButton)?_c('i',{staticClass:"cr-tag-remove-button",on:{"click":_vm.remove}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }